import React, {useEffect, useRef, useState} from 'react'
import Popup from "./popup";
import {PopupAlts, PopupAssets, PopupPositions, PopupSizes} from "../pages/front_page_data";

export default function PopupCanvas({highlighted = null})
{    
    let [shouldDisplay, setShouldDisplay] = useState(false);    
    
    useEffect(() => {
        if (highlighted === null) {
            setShouldDisplay(false)
        } else {
            setShouldDisplay(PopupAssets.Get(highlighted.id) != null);          
        }
    }, [highlighted]);
    
    return (
        <div id={"popup canvas"}>            
            {highlighted !== null && shouldDisplay ?                
                <Popup
                    highlighted={highlighted}
                    popup_id={highlighted.id}
                    img_src={PopupAssets.Get((highlighted.id))}
                    position={PopupPositions.Get(highlighted.id)}
                    width={PopupSizes.Get(highlighted.id)}
                    alt={PopupAlts.Get(highlighted.id)}
                />
                : null            
            }
        </div>
    )
}